import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible';
import Vant from 'vant';
import { Locale } from 'vant';
import esES from 'vant/lib/locale/lang/es-ES';
import 'vant/lib/index.css';
import '@/assets/css/border-1px.css'
import '@/assets/lib-flexible'
import axios from 'axios'
import '@/assets/css/van.scss'
import JSBridge from '@/common/jsBridge'
import { dateFormat, relativeTimeFilter, shortDateTime } from '@/tool/dayFilter'
import eruda from 'eruda'

if (process.env.VUE_APP_BUILD_ENV === "test") {
  eruda.init();
}

// 挂载到Vue原型
Vue.prototype.$jsBridge = new JSBridge()

// 注册全局过滤器
Vue.filter('dateFormat', dateFormat)
Vue.filter('relativeTime', relativeTimeFilter)
Vue.filter('shortDateTime', shortDateTime)

// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole);
console.log(process.env.NODE_ENV, 'process.env.NODE_ENV----------')
// if (!process.env.NODE_ENV === 'production') {
//   const vConsole = new VConsole()
//   Vue.use(vConsole);
// }
// 也可以将dayjs挂载到Vue原型上，方便组件内使用
import dayjs from '@/tool/dayFilter'
Vue.prototype.$dayjs = dayjs

Vue.use(Vant);
Locale.use('es-ES', esES);
Vue.config.productionTip = false

new Vue({
  axios,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
